// src/shared/season.js — Saison ausgeschrieben (App). Gleiche Logik wie lib/season-format.js für die
// öffentliche Platzseite (test/season.test.js prüft die Gleichheit).

export const MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
// Nur ein Monatsbereich, optional mit Tagen und einem OSM-Kommentar in Anführungszeichen — alles andere bleibt roh.
const RANGE_ONLY = /^([A-Z][a-z]{2})\s*(\d{1,2})?\s*-\s*([A-Z][a-z]{2})\s*(\d{1,2})?\s*(?::\s*".*")?$/;
const lastDay = (m) => new Date(2025, m + 1, 0).getDate();

/**
 * Saison lesbar machen: „Mar-Nov“ → „März – November“, „Mar 15 - Oct 31“ → „15. März – Oktober“.
 * allYear = übersetzter Text für „ganzjährig“. Nicht erkannte Werte (Öffnungszeiten, Freitext) kommen roh zurück.
 */
export function formatSeason(raw, locale, allYear) {
  const s = String(raw == null ? '' : raw).trim();
  if (!s) return '';
  if (/^ganzj(ä|ae)hrig$/i.test(s) || /^week\s*0?1\s*-\s*53$/i.test(s)) return allYear;
  const m = RANGE_ONLY.exec(s);
  const m1 = m ? MONTHS.indexOf(m[1]) : -1, m2 = m ? MONTHS.indexOf(m[3]) : -1;
  if (m1 < 0 || m2 < 0) return s;
  const d1 = m[2] ? +m[2] : 1, d2 = m[4] ? +m[4] : lastDay(m2);
  if (d1 < 1 || d1 > lastDay(m1) || d2 < 1 || d2 > lastDay(m2)) return s;
  if (m1 === 0 && d1 === 1 && m2 === 11 && d2 === 31) return allYear;
  const fmt = (month, day, withDay) => new Intl.DateTimeFormat(locale, withDay ? { day: 'numeric', month: 'long' } : { month: 'long' })
    .format(new Date(Date.UTC(2025, month, day, 12)));
  return fmt(m1, d1, d1 !== 1) + ' – ' + fmt(m2, d2, d2 !== lastDay(m2));
}
